var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: -5.68434189e-14,
    y: 0,
    width: 372,
    height: 1280,
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 340,
    height: 222,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 340,
    height: 174,
    rx: 12
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.8%",
    y: "-10.9%",
    width: "113.5%",
    height: "126.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.88598427%",
    y1: "100%",
    x2: "131.046449%",
    y2: "-40.0395288%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#376ECD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CC3CD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5--\\u0421\\u041C\\u041F--|---Web-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-02-\\u0421\\u041C\\u041F-|-\\u043D\\u043E\\u0432\\u0430\\u044F-\\u0437\\u0430\\u044F\\u0432\\u043A\\u0430-|-\\u0434\\u043E\\u0431\\u0430\\u0432\\u0438\\u0442\\u044C-\\u043F\\u0440\\u0435\\u0434\\u043B\\u043E\\u0436\\u0435\\u043D\\u0438\\u0435",
    transform: "translate(-880.000000, -638.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sheet",
    transform: "translate(820.000000, 398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/avatar/circle",
    transform: "translate(60.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "avatar",
    fill: "url(#linearGradient-7)",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/female-avatar",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7302219,5.4 C11.8262013,5.4 11.9182061,5.43833081 11.985795,5.5064762 L11.985795,5.5064762 L12.489742,6.01762246 C12.5578874,6.08521133 12.5962182,6.17721617 12.5962182,6.27319559 C12.5962182,6.36917501 12.5578874,6.46117985 12.489742,6.52876872 L12.489742,6.52876872 L10.077,8.946 L12.5533815,11.4225896 C12.6044905,11.4732813 12.6388288,11.5377069 12.6528037,11.6072428 L12.6598577,11.6781627 C12.6598577,11.7741422 12.6215269,11.866147 12.5533815,11.9337359 L12.5533815,11.9337359 L12.0422352,12.4448821 C11.9758844,12.5126011 11.8850683,12.5507624 11.7902617,12.5507624 C11.6954551,12.5507624 11.604639,12.5126011 11.5382882,12.4448821 L11.5382882,12.4448821 L9.06174857,9.9683425 L6.58520894,12.4520814 C6.51762007,12.5202268 6.42561524,12.5585576 6.32963581,12.5585576 C6.23365639,12.5585576 6.14165155,12.5202268 6.07406268,12.4520814 L6.07406268,12.4520814 L5.57011567,11.9409351 C5.50197028,11.8733462 5.46363947,11.7813414 5.46363947,11.685362 C5.46363947,11.5893826 5.50197028,11.4973777 5.57011567,11.4297888 L5.57011567,11.4297888 L7.982,9.012 L5.5064762,6.53596796 C5.45536716,6.48527631 5.42102882,6.42085068 5.40705396,6.35131477 L5.4,6.28039483 C5.4,6.18441541 5.43833081,6.09241057 5.5064762,6.0248217 L5.5064762,6.0248217 L6.01762246,5.51367545 C6.08397327,5.44595644 6.17478936,5.40779514 6.26959597,5.40779514 C6.36440258,5.40779514 6.45521867,5.44595644 6.52156948,5.51367545 L6.52156948,5.51367545 L8.9981091,7.99021507 L11.4746487,5.5064762 C11.5422376,5.43833081 11.6342424,5.4 11.7302219,5.4 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    transform: "translate(9.029929, 8.979279) rotate(-315.000000) translate(-9.029929, -8.979279) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGradient);
export default __webpack_public_path__ + "static/media/circle-gradient.a098297d.svg";
export { ForwardRef as ReactComponent };